export enum TreeTableRowActionType {
    BUTTON, LINK, TOGGLE_CHILD, TOGGLE_SELECT
}
